import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'
import { cn } from '@/lib/utils'

export const badgeVariants = cva(
  'inline-flex w-fit shrink-0 items-center gap-1 rounded-full border px-2 py-0.5 text-[11.5px] font-medium whitespace-nowrap [&>svg]:size-3 transition-colors',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary/10 text-primary dark:bg-primary/20 dark:text-accent-foreground',
        secondary: 'border-transparent bg-secondary text-secondary-foreground',
        outline: 'text-foreground/80',
        success: 'border-transparent bg-success/12 text-[color-mix(in_oklch,var(--success),black_25%)] dark:text-success',
        warning: 'border-transparent bg-warning/15 text-[color-mix(in_oklch,var(--warning),black_40%)] dark:text-warning',
        danger: 'border-transparent bg-danger/12 text-danger',
        offline: 'border-transparent bg-offline/15 text-muted-foreground',
        brand: 'border-transparent bg-brand-gradient text-white',
      },
    },
    defaultVariants: { variant: 'default' },
  },
)

export function Badge({ className, variant, ...props }: React.ComponentProps<'span'> & VariantProps<typeof badgeVariants>) {
  return <span data-slot="badge" className={cn(badgeVariants({ variant }), className)} {...props} />
}
